import React, { useState } from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';

import ProgynyGlobalSvg from '../../assets/progyny_global.svg';
import Link from '../../components/Link';
import NavigationList from './Navigation';
import SideFooter from './SideFooter';

const SideNavbar = () => {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('sidebarCollapsed') === 'true',
  );
  const { classes } = useStyles({ collapsed });

  const toggleSidebar = () => {
    const nextCollapsed = !collapsed;
    setCollapsed(nextCollapsed);
    localStorage.setItem('sidebarCollapsed', String(nextCollapsed));
  };

  return (
    <Paper className={classes.sidebar}>
      <Box className={classes.header}>
        {!collapsed && (
          <Link
            href="/"
            title="Home"
            aria-label="Home"
            className={classes.homeLink}
          >
            <ProgynyGlobalSvg fill="#2D3E91" />
          </Link>
        )}
        <Tooltip
          title={collapsed ? 'Expand navigation' : 'Collapse navigation'}
        >
          <IconButton
            color="primary"
            aria-label={collapsed ? 'Expand navigation' : 'Collapse navigation'}
            aria-expanded={!collapsed}
            aria-controls="sidebar-navigation"
            onClick={toggleSidebar}
            className={classes.iconButton}
          >
            {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </Tooltip>
      </Box>
      <NavigationList collapsed={collapsed} />
      <SideFooter collapsed={collapsed} />
    </Paper>
  );
};

export default SideNavbar;

const useStyles = makeStyles()((theme, { collapsed }) => ({
  sidebar: {
    height: '100vh',
    borderRight: '1px solid #E5E7EB',
    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundColor: theme.palette.action.hover,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 0,
    width: collapsed ? 64 : '40%',
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      width: collapsed ? 64 : '20%',
    },
    [theme.breakpoints.up('xl')]: {
      width: collapsed ? 64 : '13%',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: collapsed ? 'center' : 'space-between',
    minHeight: 50,
    margin: theme.spacing(2, 0),
    padding: theme.spacing(0, 1),
    gap: theme.spacing(1),
  },
  homeLink: {
    flex: 1,
    minWidth: 0,
    '& svg': { display: 'block', width: '100%' },
  },
  iconButton: {
    width: 44,
    height: 44,
    flexShrink: 0,
  },
}));
